import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Invokes `close` whenever the route changes — including pathname, search,
// or hash. This is what the Header / dropdown menus use so they auto-close
// when the user navigates anywhere new (including to a hash anchor like
// `/contact#quote`).
// `close` must be referentially stable (wrap it in useCallback).
export default function useCloseOnRouteChange(close) {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    close();
  }, [pathname, search, hash, close]);
}
